import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthService } from 'app/core/auth/auth.service';

@NgModule({ imports: [], providers: [
        AuthService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AuthModule
{
}
